export default __webpack_public_path__ + "static/media/picture_frame.6470e67f.svg";